import { defineStore } from 'pinia';
import { Location } from '~/api/models/location.model';

export const useLocationStore = defineStore('location', {
    state: () => {
        return { 
            location: null as Location | null, 
        }
    },

    actions: {
        async fetchLocation(): Promise<Location> {
            if(!('geolocation' in navigator)) {
                this.location = null;
            }

            return await new Promise<Location>((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    (position: GeolocationPosition) => resolve({lat: position.coords.latitude, lon: position.coords.longitude} as Location),
                    (error: GeolocationPositionError) => reject(error),
                )
            }).then((location: Location) => {
                this.location = location;
                return this.location;
            });
            
        }
    }
});